import { Notification } from 'APIs/letrusAPI/notifications/types';

export const NOTIFICATION_TITLE_MAX_NUMBER_OF_CHARACTERS = 75;

export const DROPDOWN_NOTIFICATION_DESCRIPTION_MAX_NUMBER_OF_CHARACTERS = 155;

export const PANEL_NOTIFICATION_DESCRIPTION_MAX_NUMBER_OF_CHARACTERS = 310;

export const NOTIFICATION_LIMIT_PER_PAGE = 10;

export const MIN_NUMBER_OF_NOTIFICATIONS_TO_ALLOW_PAGINATION = 11;

type NotificationLinkType = 'internal' | 'external';
type NotificationSeenState = 'not-received' | 'not-opened' | null;

interface UseNotificationReturn {
  getLinkType(notification: Notification): NotificationLinkType;
  hasBeenSeen(notification: Notification): boolean;
  getNotificationSeenState(notification: Notification): NotificationSeenState;
}

function useNotification(): UseNotificationReturn {
  function getLinkType(notification: Notification): NotificationLinkType {
    if (notification?.link?.includes('http')) {
      return 'external';
    }

    return 'internal';
  }

  function getNotificationSeenState(
    notification: Notification
  ): NotificationSeenState {
    if (!notification.received) {
      return 'not-received';
    }

    if (
      (notification.channel as string) === 'recommendation' &&
      !notification.opened
    ) {
      return 'not-opened';
    }

    if (notification.link && !notification.opened) {
      return 'not-opened';
    }

    return null;
  }

  function hasBeenSeen(notification: Notification): boolean {
    return notification.link ? !!notification.opened : !!notification.received;
  }

  return {
    getLinkType,
    hasBeenSeen,
    getNotificationSeenState,
  };
}

export default useNotification;
